import React from 'react'
import PrintView from '../../components/PrintView/PrintView'
import image from '../../assets/images/perfect-product.jpg'

const PerfectView = () => {
  return <PrintView
  title='The view is a 10/10. The comfort is 1000/10'
  heading='The view is a 10/10. The comfort is 1000/10'
  content='Dreams do come true. This is one of my absolute favorite shots that I was longing to take. I was able to capture this going down my favorite and unique lane in the Yala National Park. This is one of my dream captures throughout this career.'
  printImage={image}
 />
}

export default PerfectView